import React, { Component } from 'react';
import { connect } from 'react-redux';
import Session from './Session';
import Shortcuts from './Shortcuts';
import Notifications from './Notifications';
import Admin from './Admin';
import Header from './Header';
import Footer from './Footer';
import Title from './Title';
import Invitation from './Invitation';
import Registry from './Registry';
import Travel from './Travel';
import Welcome from './Welcome';
import RSVP from './RSVP';
// import Suggestions from './Suggestions';
import NyanCat from './NyanCat';
import Photos from './Photos';
import { bindActionCreators } from 'redux';
import './Main.css';
import './RegularStyle.css';
import './CodeStyle.css';
import './Section.css';
import { visited, inviteeUpdated } from '../actions/invitee';

const mapStateToProps = state => ({
  invitee: state.invitee,
  adminMode: state.admin.adminMode,
  activeStyle: state.styles.activeStyle,
  konamiMode: state.styles.konamiMode,
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ inviteeUpdated }, dispatch);
}

const View = ({ konamiMode }) => (
  <div>
    <Header />
    {konamiMode === true && <NyanCat />}
    <Welcome section="1" />
    <Invitation section="2" />
    <RSVP section="3" />
    <Travel section="4" />
    <Registry section="5" />
    {/* <Suggestions section="5" /> */}
    <Photos section="6" />
    <Footer />
  </div>
);

class Main extends Component {
  url = process.env.REACT_APP_API_URL;

  componentDidMount() {
    setTimeout(() => {
      const id = this.props.invitee.id;
      if (id !== null) {
        visited(id);
        this.getInviteeFromDatabase(id);
      }
    }, 1000);
  }

  async getInviteeFromDatabase(id) {
    let invitee = null;

    try {
      const result = await fetch(`${this.url}/invitees/${id}`);

      if (result.status !== 200) throw result.status;
      const data = await result.json();
      invitee = Object.assign({}, data, { id });
    } catch (err) {
      console.log(`invitee doesn't exist`);
      console.log(err);
    }

    if (invitee !== null) {
      this.props.inviteeUpdated(invitee);
    }
  }

  render() {
    return (
      <div className={`custom-style-${this.props.activeStyle}`}>
        {this.props.invitee.authorized && (
          <Admin invitee={this.props.invitee} />
        )}
        <Session />
        <Shortcuts />
        <Notifications />
        <Title section="0" />
        {this.props.invitee.authorized && <View {...this.props} />}
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Main);



// WEBPACK FOOTER //
// ./src/components/Main.js